import axios from "axios";

export const submitFeedback = async (data) => {
  try {
    const res = await axios.post(`/api/feedback-widget`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return res;
  } catch (error) {
    throw error;
  }
};
